import { useState } from "react";

const formForm = ({ form, application, onClose, edit }) => {
  const [values, setValues] = useState(() => {
    if (application?.form?.fields) {
      const initial = {};
      application.form.fields.forEach(f => {
        initial[f.name] = f.value;
      });
      return initial;
    }
    return {};
  });

  const handleChange = (id, value) => {
    setValues(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fieldsArray = Object.entries(values).map(([name, value]) => ({
      name,
      value
    }));

    const method = edit ? "PATCH" : "POST";
    const endpoint = edit
      ? `/applications/${application.id}/form`
      : `/applications/${application.id}/form`;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
        {
          method,
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
          body: JSON.stringify({ fields: fieldsArray }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al enviar el formulario");
      }

      const data = await response.json();

      onClose?.();
    } catch (error) {
      alert("Hubo un problema al guardar el formulario");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-2">{form.name}</h2>
      <p className="text-gray-600 mb-6">{form.description}</p>

      <form className="space-y-6" onSubmit={handleSubmit}>
        {form.fields.map((field) => (
          <FieldRenderer
            key={field.name}
            field={field}
            value={values[field.name] || ""}
            onChange={handleChange}
          />
        ))}

        <div className="flex space-x-4 pt-6 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancelar
          </button>

          <button
            type="submit"
            className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Completar Formulario
          </button>
        </div>
      </form>
    </div>
  );
};

const FieldRenderer = ({ field, value, onChange }) => {
    const baseClasses =
      "w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500";
  
    const update = (e) => onChange(field.name, e.target.value);
  
    switch (field.type) {
      case "text":
      case "email":
      case "phone":
        return (
          <div>
            <label className="block text-sm font-medium mb-2">
              {field.label} {field.required && "*"}
            </label>
            <input
              type={field.type === "phone" ? "tel" : field.type}
              placeholder={field.placeholder}
              className={baseClasses}
              value={value}
              onChange={update}
            />
          </div>
        );
  
      case "textarea":
        return (
          <div>
            <label className="block text-sm font-medium mb-2">
              {field.label} {field.required && "*"}
            </label>
            <textarea
              value={value}
              onChange={update}
              placeholder={field.placeholder}
              className={`${baseClasses} h-24 resize-none`}
            />
          </div>
        );
  
      case "select":
        return (
          <div>
            <label className="block text-sm font-medium mb-2">
              {field.label} {field.required && "*"}
            </label>
            <select
              value={value}
              onChange={update}
              className={baseClasses}
            >
              <option value="">Selecciona una opción...</option>
              {field.options?.map((o, i) => (
                <option key={i} value={o}>
                  {o}
                </option>
              ))}
            </select>
          </div>
        );
  
      case "checkbox":
        return (
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={value || false}
              onChange={(e) => onChange(field.name, e.target.checked)}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded"
            />
            <span className="text-sm">{field.label}</span>
          </div>
        );
  
      case "file":
        return (
          <div>
            <label className="block text-sm font-medium mb-2">
              {field.label} {field.required && "*"}
            </label>
            <input
              type="file"
              onChange={(e) => onChange(field.name, e.target.files[0])}
              className={baseClasses}
            />
          </div>
        );
  
      default:
        return null;
    }
  };
  
export default formForm;
  